import reset from './reset.svg'
import rotate from './rotate.svg'
import zoomIn from './zoom-in.svg'
import zoomOut from './zoom-out.svg'

const ICONS = {
    reset,
    rotate,
    zoomIn,
    zoomOut,
}

export default ICONS
